// extracted by mini-css-extract-plugin
export default {"CardDeclaration":"styles_CardDeclaration__-dXa1","Title":"styles_Title__OhMDb","CardFooter":"styles_CardFooter__N2o2V"};